import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { HandWithPhone } from '@tink/core/src/components/atoms/Icons/HandWithPhone';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { MarketCode } from '@tink/config/src/markets';
import { Stack } from '../../atoms/Stack/Stack';
import { PrimaryButton } from '../../atoms/Button/Button';
import { ScreenWrapper } from '../../atoms/ScreenWrapper/ScreenWrapper';
import { Provider, ProviderEntity } from '../../../models/provider';
import { useAnalytics } from '../../../core/Analytics/AnalyticsProvider';
import { PageView } from '../../../models/analytics';
import { ContentBody } from '../../atoms/ContentBody/ContentBody';
import { Footer } from '../../atoms/Footer/Footer';
import { ApplicationUnverifiedLabel } from '../../molecules/ApplicationUnverifiedLabel/ApplicationUnverifiedLabel';
import { messages as addCredentialsMessages } from '../SubmitCredentials/messages';
import { H1 } from '../../atoms/Heading/Heading';
import { BackButton } from '../../organisms/Header/HeaderMolecule';
import { useCredentialsCopy } from '../SubmitCredentials/hooks/useCredentialsCopy';
import { useUrlQuery } from '../../ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import { AwaitingScreenHeader } from './organisms/molecules/AwaitingScreenHeader/AwaitingScreenHeader';
import {
  IconContainer,
  ImageContainer,
  StyledImage,
  ThemedIcon,
} from './AwaitingTppRedirectScreen.styles';
import { MxLabel } from './atoms/MxLabel/MxLabel';

export type AwaitingTppRedirectScreenProps = {
  provider: ProviderEntity;
  clientName?: string;
  onClick: () => void;
  isVerified: boolean;
} & BackButton;

export const AwaitingTppRedirectScreen: React.FC<AwaitingTppRedirectScreenProps> = ({
  provider,
  onBack,
  onClick,
  isVerified,
}) => {
  const { tinklinkAnalytics } = useAnalytics();
  const { heading: customHeading } = useCredentialsCopy();
  const { market } = useUrlQuery();
  const isMarketUS = market === MarketCode.US;

  useEffect(() => {
    tinklinkAnalytics.sendViewEvent({ view: PageView.AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN });
  }, [tinklinkAnalytics]);

  return (
    <ScreenWrapper>
      <AwaitingScreenHeader
        allowExit={Boolean(onBack)}
        onBack={onBack}
        pageView={PageView.AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN}
      />
      <ContentBody centerVertically centerHorizontally data-testid="tpp-redirect-screen">
        {!isVerified && (
          <Box my="medium">
            <ApplicationUnverifiedLabel isVerified={false} />
          </Box>
        )}
        <Stack justifyContent="center">
          <IconContainer>
            <ThemedIcon>
              <HandWithPhone />
            </ThemedIcon>
            <ImageContainer>
              <StyledImage src={Provider.getIcon(provider)} alt="" />
            </ImageContainer>
          </IconContainer>
          <H1 align="center">{customHeading}</H1>
        </Stack>
        <Footer stickToBottom>
          <PrimaryButton
            pageView={PageView.AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN}
            variant="contained"
            color="primary"
            onClick={onClick}
          >
            <FormattedMessage {...addCredentialsMessages.continue} />
          </PrimaryButton>
        </Footer>
        {isMarketUS && <MxLabel />}
      </ContentBody>
    </ScreenWrapper>
  );
};
